import Vue from "vue";

export const STARUPFALCON_COM_CONFIG = {
    'IS_PROD': true,
    'API_PATH': 'https://api.startupfalcon.com/',
    'SEGMENT_KEY': 'dr9grHfBM2OqBVJ3pVa3hZqXR8KYmBrw',
    'STRIPE': 'pk_live_q943tkBHzxuxaNTM8Yke9XIx000DkFMewA',
    'COOKIE_DOMAIN': '.startupfalcon.com',
    'HOMEPAGE': 'https://startupfalcon.com/',
    'INTEGRATIONS':[
        //sentry
        function(){
            Sentry.init({
                dsn: "https://7e8c03ae418949cfa45fd883b8ed0c30@o475019.ingest.sentry.io/5517246",
                integrations: [
                    new Sentry.Integrations.Vue({
                        Vue,
                        tracing: true,
                    }),
                    new Sentry.Integrations.BrowserTracing(),
                ],

                // We recommend adjusting this value in production, or using tracesSampler
                // for finer control
                tracesSampleRate: 1.0,
            });
        },
        function () {
            $("body").append('<script id="calendlyWidget" src="https://assets.calendly.com/assets/external/widget.js" type="text/javascript" async></script>');
        },
        function () {
            $('head').prepend(`
            <!-- Global site tag (gtag.js) - Google Ads: 408551170 -->
            <script async src="https://www.googletagmanager.com/gtag/js?id=AW-408551170"></script>
            <script>
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
            
              gtag('config', 'AW-408551170');
            </script>
            `)
        },
        function () {
            $('head').prepend(`
             <script async defer src="https://tools.luckyorange.com/core/lo.js?site-id=c9098c5a"></script>
            `)
        },
        function () {
           $('head').prepend(`
             <script async defer src="https://www.googletagmanager.com/gtag/js?id=G-Q8MH98FFJ7"></script>
           `);

           window.dataLayer = window.dataLayer || [];
            function gtag() {
                dataLayer.push(arguments);
            }
            gtag('js', new Date());
            gtag('config', 'G-Q8MH98FFJ7');
        }
    ],
    INTERCOM_TOUR_ID: 223174,
    DEMO_REPORT_ID: 43,
}
